/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faListAlt} from '@fortawesome/pro-duotone-svg-icons';

const GrantProgramsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faListAlt} {...props} />
);

export default GrantProgramsIcon;
